module.exports = __webpack_public_path__ + "14four/static/media/FrostBorderTop.649d6320.png";